import HttpService from "./htttp.service";

class PaymentService {
  // Obtém o link do Portal do Cliente Stripe
  getPortalUrl = async () => {
    return await HttpService.post("payments/portal");
  };

  // Checkout do Premium. plan: "monthly" | "yearly"
  createSubscription = async (plan) => {
    return await HttpService.post("payments/create-subscription", { plan });
  };

  // Status real do Checkout (API consulta o Stripe + status gravado pelo webhook)
  getCheckoutStatus = async (sessionId) => {
    return await HttpService.get(`payments/checkout-status?session_id=${encodeURIComponent(sessionId)}`);
  };
}

export default new PaymentService();